import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-luxury-bg flex items-center justify-center">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 bg-luxury-surface border-b border-luxury-border z-10">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-luxury-elevated border border-luxury-gold/40 rounded-lg flex items-center justify-center">
              <span className="text-luxury-gold font-bold text-sm">TV</span>
            </div>
            <span className="font-bold text-luxury-text text-lg">TaxVault</span>
          </div>
        </div>
      </nav>

      {/* 404 Content */}
      <div className="flex flex-col items-center justify-center text-center max-w-md px-6">
        <div className="text-8xl mb-6 font-bold text-luxury-gold">404</div>
        <h1 className="text-4xl font-bold text-luxury-text mb-3">Page Not Found</h1>
        <p className="text-luxury-secondary text-lg mb-8">
          The page you're looking for doesn't exist. Let's get you back on track.
        </p>
        <button
          onClick={() => navigate("/dashboard")}
          className="px-8 py-3 bg-luxury-cta hover:bg-luxury-cta-hover text-white font-semibold rounded-xl transition active:scale-95"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
